export class AuthenticationError extends Error {
} // AuthenticationError

export class ResponseError extends Error {
} // ResponseError

// kate: replace-tabs on; tab-width 4; show-tabs on;
